import { EventData, PageViewData } from '../tracking/tealium';
import { trackTealium } from '../src/tracking';
import { trackEvent as trackerTrackEvent } from '@tuic/tracking';
import { normalizeTrackingValue } from '@tuic/tracking/src/utils/normalize-tracking-value';
import { isUsingTrackerModule } from '../tracking/tealium-helper';

export const formatTrackingString = normalizeTrackingValue;

export const trackPageView = (data: PageViewData) => {
  trackTealium(data, 'Pageview');
};

/**
 * Use `queueTrackEvent` instead.
 */
export const trackEvent = (data: EventData) => {
  if (isUsingTrackerModule()) {
    trackerTrackEvent(data);
    return;
  }

  trackTealium(data, 'Event');
};
